module.exports = __webpack_public_path__ + "assets/img/默认用户.2f2fbec4.png";